import { Button, Checkbox, Chip, Grid, ListItemText, MenuItem, TextField, Tooltip } from '@material-ui/core';
import { DeleteSweep } from '@material-ui/icons';
import DeleteIcon from '@material-ui/icons/CancelRounded';
import { ErrorAPI } from 'api/Assessor/methods';
import { AxiosError } from 'axios';
import GenericModal, { IGenericModalProps } from 'components/GenericModal/GenericModal';
import { CircleAddIcon, CircleCheckIcon, InvertedChevronIcon, SyncIcon } from 'components/Icons';
import AssembleiaProduto from 'models/AssembleiaProduto';
import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect, useDispatch, useSelector } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { assembleiasAssessorActionsLoadPautas, assembleiasAssessorCadastrarPauta } from 'store/modules/AssembleiasAssessorActions';
import { ICadastrarPautaRequest, IItensCadastrarPautaRequest } from 'store/modules/AssembleiasAssessorReducer';
import { modalsActionsClose } from 'store/modules/ModalsActions';
import { ModalsActionsClose } from 'store/modules/ModalsActionTypes';
import { IModalProps } from 'store/modules/ModalsReducer';
import { IReducer } from 'store/Reducer';
import ErrorHandler from 'utils/ErrorHandler';
import { getToastError, getToastSuccess } from 'utils/ToasterUtils';
import TextRange from 'utils/TextRange';
import { useStyles } from './styles';

const MAX_IMPUT_LENGHT = 200;
const MAX_TITLE_LENGHT = 250;
const MAX_DESC_LENGHT = 500;

export interface ICadastroPautaModalProps extends IGenericModalProps {
  key: string,
  idEvento: number,
  status: number,
  idsProdutos?: number[],
  idPauta?: number,
  titulo?: string,
  descricao?: string,
  itens?: IItensCadastrarPautaRequest[],
  produtosAssembleia: AssembleiaProduto[]
}

export interface ICadastroPautaModal extends IModalProps {
  genericProps?: ICadastroPautaModalProps,
  modalsActionsClose: (key: string) => ModalsActionsClose,
  assembleiasAssessorCadastrarPauta: (pautaRequest: ICadastrarPautaRequest, callbackSuccess?: () => void, callbackError?: (error: AxiosError) => void) => void,
}

const mapStateToProps = (state:IReducer) => {
  return {
    assembleia: state.assembleiasAssessor
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({
  modalsActionsClose,
  assembleiasAssessorCadastrarPauta
}, dispatch);

const CadastroPautaModal = ( { genericProps, modalsActionsClose, assembleiasAssessorCadastrarPauta }: ICadastroPautaModal ) => {

  const classes = useStyles();
  const { t } = useTranslation();
  const [ titulo, setTitulo ] = useState('');
  const [ descricao, setDescricao ] = useState('');
  const [ produtosSelecionados, setProdutosSelecionados ] = useState<number[]>(genericProps!.idsProdutos || []);
  const [ opcaoVoto, setOpcaoVoto ] = useState('');
  const [ itensState , setItensState ] = useState<IItensCadastrarPautaRequest[]>([]);
  const reduxDispatch = useDispatch();
  const usuario = useSelector((state: IReducer) => state.auth.usuario);
  const [ isEdit, setIsEdit ] = useState(false);
  const [ salvando, setSalvando ] = useState<boolean>(false);
  // const { loadingProdutos, produtos } = useSelector((state: IReducer) => state.assembleiasAssessor);

  const toClose = useCallback((): void => {
    if (genericProps && genericProps.key) {
      modalsActionsClose(genericProps.key);
    }
  },[genericProps, modalsActionsClose])

  const handleTituloChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setTitulo(TextRange(event.target.value, MAX_TITLE_LENGHT));
  };

  const handleDescricaoChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setDescricao(TextRange(event.target.value, MAX_DESC_LENGHT));
  };

  const handleOpcaoVotoChange = (event: React.ChangeEvent<{ value: unknown }>) => {

    const opcao = (event.target.value as string);
    setOpcaoVoto(opcao);

  };

  const handleAddNewOp = useCallback(( opcao: string ) => {
    const _itensState = Array.from(itensState);
    const op: IItensCadastrarPautaRequest = {
      descricao: opcao,
      flgAbstencao: false,
      ordem: 0,
    };
    _itensState.push(op);
    setOpcaoVoto('');
    setItensState(
      _itensState.map((entry, i) => {
        entry.ordem = i;
        return entry;
      })
    );
  }, [itensState]);

  const removeItem = useCallback(( index: number ) => {
    const _itensState = Array.from(itensState).filter((entry, i) => i !== index);
    setItensState(_itensState);
  }, [itensState]);

  const getItens = useCallback(() => {
    if ( itensState && itensState.length > 0 ) {
      return itensState.map((it, index) => {
        return (
          <Grid container className={ classes.itensList } key={ index }>
            <Tooltip title={ it.descricao }>
              <Grid item xs={12} sm={12} md={12} lg={12} className={ classes.itemText }>
                <p className={ classes.text }>
                  {
                    !it.flgAbstencao ? (
                      <Tooltip title={ `${ t("CadastroPautaModal.tooltipButtomDeletar") }` }>
                        <Button
                          onClick={ () => removeItem( index ) }
                          className={ classes.deleteButton }
                          disabled={ salvando }
                        >
                          <DeleteSweep color="primary"/>
                        </Button>
                      </Tooltip>
                    ) : null
                  }
                  {
                    !it.flgAbstencao ?
                      <b>{ it.descricao }</b>
                    :
                      <b className={ classes.abstencao }>{ it.descricao }</b>
                  }
                </p>
              </Grid>
            </Tooltip>
          </Grid>
        )
      });
    }
  }, [itensState, classes, removeItem, salvando, t]);

  const isButtonAddDisabled = () => {
    return opcaoVoto.trim().length === 0;
  }

  const isConfirmButtonDisabled = () => {
    return (titulo.trim() === '' || produtosSelecionados.length === 0) ? true : false;
  }

  const showError = (error: AxiosError<ErrorAPI>) => {
    setSalvando(false);
    ErrorHandler(error.response!.data);
  }
  // eslint-disable-next-line
  const atualizarPautas = useCallback(() => {
    window.setTimeout(() => {
      reduxDispatch(
        assembleiasAssessorActionsLoadPautas(
          genericProps!.idEvento,
          usuario!.cpfCnpj,
          () => {
            setSalvando(false);
            toClose();
          },
          showError
        )
      )
    }, 2000);
  }, [reduxDispatch, genericProps, usuario, toClose])

  const toSubmmit = useCallback(() => {
    if (genericProps && genericProps.idEvento) {
      let pautaRequest: ICadastrarPautaRequest = {
        descricao: descricao,
        idAssembleia: genericProps.idEvento,
        itens: itensState,
        titulo: titulo,
        idsProdutos: produtosSelecionados
      }

      let pautaRequestEdit: ICadastrarPautaRequest = {
        descricao: descricao,
        idAssembleia: genericProps.idEvento,
        itens: itensState,
        titulo: titulo,
        idPauta: genericProps.idPauta,
        idsProdutos: produtosSelecionados
      }

      setSalvando(true);

      isEdit ?
      assembleiasAssessorCadastrarPauta(
        pautaRequestEdit,
        () => {
          getToastSuccess( t( "EditarPauta.succesEditarPauta" ) );
          // atualizarPautas();
          setSalvando(false);
          toClose();
        },
        error => {
          setSalvando(false);
          getToastError( error.response?.data.message || t( "EditarPauta.errorEditarPauta" ) )
        }
      )
      :
      assembleiasAssessorCadastrarPauta(
        pautaRequest,
        () => {
          getToastSuccess( t( "CadastroPautaModal.succesCastroPauta" ) );
          // atualizarPautas();
          setSalvando(false);
          toClose();
        },
        error => {
          setSalvando(false);
          getToastError( error.response?.data.message || t( "CadastroPautaModal.errorCastroPauta" ) )
        }
      )
    }
  },[genericProps, produtosSelecionados, assembleiasAssessorCadastrarPauta, descricao, titulo, t, itensState, toClose, isEdit]);

  useEffect(() => {
    if ( genericProps && genericProps.idPauta ) {
      setIsEdit( true );
      setTitulo( genericProps?.titulo || '' );
      setDescricao( genericProps?.descricao || '' );
      setItensState( genericProps?.itens || [] );
    }
  }, [ genericProps ]);

  const onDeleteProduto = useCallback((idProduto: number) => {
    const newValues = [ ...produtosSelecionados ];
    newValues.splice(newValues.indexOf(idProduto), 1);
    setProdutosSelecionados(newValues);
  }, [produtosSelecionados, setProdutosSelecionados])

  return (
    <GenericModal
      title={ isEdit ? t("EditarPauta.title") : t("CadastroPautaModal.title") }
      content={
        <Grid container>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <TextField
              label={ t(`CadastroPautaModal.produtosPautaLabel`) }
              className={ classes.textSelectItens }
              value={ produtosSelecionados }
              disabled={ salvando }
              SelectProps={{
                onChange: (event) => setProdutosSelecionados(event.target.value as number[]),
                renderValue: selected => {
                  return (genericProps?.produtosAssembleia || [])
                    .filter(
                      (produto: AssembleiaProduto): boolean => {
                        return (selected as number[]).indexOf(produto.idProduto) > -1
                      })
                    .map(
                      (produto: AssembleiaProduto, key: number) => {
                        return (
                          <Chip
                            color="primary"
                            key={ key }
                            label={ produto.codigo + ' - ' + produto.titulo }
                            style={{zIndex: 9999, position: 'relative'}}
                            deleteIcon={
                              <div onMouseDown={(event) => {
                                event.preventDefault();
                                event.stopPropagation();
                                onDeleteProduto(produto.idProduto);
                              }}>
                                <DeleteIcon className="MuiSvgIcon-root MuiChip-deleteIcon MuiChip-deleteIconColorPrimary" style={{margin: '0px 5px 0px 0px'}} />
                              </div>
                            } />
                        )
                      }
                    );
                },
                multiple: true,
                IconComponent: () => (
                  <InvertedChevronIcon className={classes.dropdownIcon} />
                ),
              }}
              select
            >
              {
                genericProps!.produtosAssembleia.map((produto: AssembleiaProduto, key: number) => {
                  return (
                    <MenuItem value={ produto.idProduto } key={ key }>
                      <Checkbox color="primary" checked={produtosSelecionados.indexOf(produto.idProduto) > -1} />
                      <ListItemText primary={ produto.codigo + ' - ' + produto.titulo } />
                    </MenuItem>
                  )
                })
              }
            </TextField>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <TextField
              label={t('CadastroPautaModal.tituloPautaLabel')}
              onChange={ handleTituloChange }
              value={ titulo }
              className={ classes.textItens }
              inputProps={{
                maxLength: MAX_TITLE_LENGHT
              }}
              helperText={`${titulo.length}/${MAX_TITLE_LENGHT}`}
              rowsMax={3}
              disabled={ salvando }
              fullWidth
              multiline
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <TextField
              label={t('CadastroPautaModal.descricaoPauta')}
              value={ descricao }
              onChange={ handleDescricaoChange }
              className={ classes.textItens }
              inputProps={{
                maxLength: MAX_DESC_LENGHT
              }}
              helperText={`${descricao.length}/${MAX_DESC_LENGHT}`}
              rowsMax={3}
              disabled={ salvando }
              fullWidth
              multiline
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Grid container>
              <Grid item xs={12} sm={8}>
                <TextField
                  label={t('CadastroPautaModal.opcaoVotoLabel')}
                  value={ opcaoVoto }
                  onChange={ handleOpcaoVotoChange }
                  className={ classes.textItens }
                  inputProps={{
                    maxLength: MAX_IMPUT_LENGHT
                  }}
                  disabled={ salvando }
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<CircleAddIcon />}
                  onClick={ () => handleAddNewOp( opcaoVoto ) }
                  disabled={ salvando || isButtonAddDisabled() }
                  className={ classes.buttonAdicionar }
                >
                  <div>{ t('CadastroPautaModal.labelButtonAdicionar') }</div>
                </Button>
              </Grid>
            </Grid>
          </Grid>
          {
            itensState.length > 0 ?
              <Grid container className={ classes.itensContainer }>
                <Grid item xs={12} sm={12} md={12} lg={12} className={ classes.itensContainerTitle }>
                  {
                    t('CadastroPautaModal.itensContainerTitle')
                  }
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  {
                    getItens()
                  }
                </Grid>
              </Grid>
            :
             null
          }
          <Grid item xs={12} sm={12} md={12} lg={12} className={ classes.confirmButtom }>
            <Button
              variant="contained"
              color="primary"
              onClick={ () => toSubmmit() }
              disabled={ salvando || isConfirmButtonDisabled() }
              startIcon={<CircleCheckIcon />}
              endIcon={ salvando ? <SyncIcon className="animation-rotate" /> : null }
            >
              { t('CadastroPautaModal.confirmButtom') }
            </Button>
          </Grid>
        </Grid>
      }
      genericProps={{
        maxWidth: 'sm',
        onClose: salvando ? undefined : toClose,
      }}
    />
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(CadastroPautaModal);
